import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';

import ClientCheckBox from '../clientFields/ClientCheckbox';
import ClientTextField from '../clientFields/ClientTextField';
import ClientTextarea from '../clientFields/ClientTextarea';

function AdsTab({
  validateFunc,
  setFunction,
  data,
  structure,
  permissions = {},
}) {
  const setter = setFunction;
  const [liveData, setLiveData] = useState({ ...data });
  const [userPermissions, setUserPermissions] = useState({ ...permissions });
  const [dataStructure, setDataStructure] = useState({ ...structure });

  useEffect(() => {
    setLiveData(data);
    setUserPermissions(permissions);
    setDataStructure(structure);
  }, [data]);

  return (
    <>
      <div className="ads-spacing">
        <ClientCheckBox
          setFunction={setter}
          data={liveData.is_ads_reporting_active}
          attribute="is_ads_reporting_active"
          label="Ads Reporting Active"
          permissions={userPermissions}
          structure={dataStructure}
        />
      </div>
      <div id="ads-columns">
        <div id="ads-info">
          <Card variant="outlined" sx={{ p: 3 }}>
            <h2>Ads Configuration</h2>
            <p>
              This field stores the client&apos;s ads configuration settings for Champy reporting
            </p>
            <ClientTextarea
              validateFunc={validateFunc}
              setFunction={setter}
              data={liveData.ads_configuration}
              attribute="ads_configuration"
              label="Ads Configuration"
              permissions={userPermissions}
              structure={dataStructure}
              minRows={6}
              maxRows={10}
            />
          </Card>
          <Card variant="outlined" sx={{ p: 3 }}>
            <h2>Commission</h2>
            <p>
              This field stores commission settings for Champy reporting
            </p>
            <ClientTextarea
              validateFunc={validateFunc}
              setFunction={setter}
              data={liveData.ads_commissions}
              attribute="ads_commissions"
              label="Commission"
              permissions={userPermissions}
              structure={dataStructure}
              minRows={6}
              maxRows={10}
            />
          </Card>
        </div>
        <Card
          id="ads-data-source"
          className="client-card"
          variant="outlined"
          sx={{ p: 3 }}
        >
          <h2>Ads Data Source IDs</h2>
          <p>Account IDs for ads data sources</p>
          <ClientTextField
            setFunction={setter}
            data={liveData.facebook_account_ids}
            attribute="facebook_account_ids"
            label="Facebook Account IDs"
            permissions={userPermissions}
            structure={dataStructure}
          />
          <ClientTextField
            setFunction={setter}
            data={liveData.facebook_locations}
            attribute="facebook_locations"
            label="Facebook Locations"
            permissions={userPermissions}
            structure={dataStructure}
          />
          <ClientTextField
            setFunction={setter}
            data={liveData.google_account_ids}
            attribute="google_account_ids"
            label="Google Account IDs"
            permissions={userPermissions}
            structure={dataStructure}
          />
          <ClientTextField
            setFunction={setter}
            data={liveData.bing_account_ids}
            attribute="bing_account_ids"
            label="Bing Account IDs"
            permissions={userPermissions}
            structure={dataStructure}
          />
          <ClientTextField
            setFunction={setter}
            data={liveData.twitter_account_ids}
            attribute="twitter_account_ids"
            label="Twitter Account IDs"
            permissions={userPermissions}
            structure={dataStructure}
          />
          <ClientTextField
            setFunction={setter}
            data={liveData.outbrain_account_ids}
            attribute="outbrain_account_ids"
            label="Outbrain Account IDs"
            permissions={userPermissions}
            structure={dataStructure}
          />
          <ClientTextField
            setFunction={setter}
            data={liveData.code_dictionary_url}
            attribute="code_dictionary_url"
            label="Code Dictionary URL"
            permissions={userPermissions}
            structure={dataStructure}
          />
        </Card>
      </div>
    </>
  );
}

export default AdsTab;

AdsTab.propTypes = {
  permissions: PropTypes.oneOfType([PropTypes.object]),
  structure: PropTypes.oneOfType([PropTypes.object]),
  setFunction: PropTypes.func,
  validateFunc: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};
